<template>
  <table class="table table-striped table-bordered table-hover">
    <thead class="thead-dark">
      <tr>
        <th scope="col">{{ tableTimePeriod }}</th>
        <th scope="col" class="text-center">Orders</th>
        <th scope="col" class="text-center">Items</th>
        <th scope="col" class="text-right">Sales</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(data, index) in tableData" :key="index">
        <th scope="row" v-if="timePeriod === 'daily'">
          {{ moment(momentHour(data.date), momentFormat) }}
        </th>
        <th scope="row" v-else>
          {{ moment(data.date, momentFormat) }}
        </th>
        <td class="text-center">{{ addCommasToInteger(data.total_orders) }}</td>
        <td class="text-center">{{ addCommasToInteger(roundInteger(data.total_items)) }}</td>
        <td class="text-right">£{{ addCommasToInteger(roundCurrency(data.total_sales)) }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "dataTable",
  props: {
    timePeriod: String,
    tableData: Array,
    momentFormat: String,
    tableTimePeriod: String
  }
};
</script>
